export type PayBalanceDueFn = (payload: {
    billingProfileId: string;
    request: {
        stripePaymentMethodId: string;
        giftCardId?: string;
    };
    accessToken: string;
}) => Promise<unknown>;
/**
 * TODO:
 * Add return type above
 */

export function initPayBalanceDueFn({
    baseUrl,
}: {
    baseUrl: string;
}): PayBalanceDueFn {
    const href =
        'billing/v1/billing-profiles/{billingProfileId}/balance-due/pay';
    return async ({ billingProfileId, request, accessToken }) => {
        const url = `${baseUrl}/${href.replace('{billingProfileId}', billingProfileId)}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json; charset=utf-8',
                Authorization: 'Bearer {accessToken}'.replace(
                    '{accessToken}',
                    accessToken,
                ),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
        if (!response.ok) return Promise.reject(await response.json());
        return response.json();
    };
}
